import {
  Box,
  Button,
  CircularProgress,
  Modal,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import {
  ModalActionButtonStyles,
  ModalBaseStyles,
  ModalHeader,
} from "../Common/styles/modal";
import { LabelStyle } from "../Common/styles/form";
import { errorToastMessage } from "../../utils/toast";
import { AxiosResponse } from "axios";
import http from "../../utils/http";

type CredProps = {
  clientId: string;
  clientSecret?: string;
};

type Props = {
  openModal: boolean;
  closeModal: () => void;
  setCredData: React.Dispatch<React.SetStateAction<CredProps | null>>;
};

const ConfirmRegeneration: React.FC<Props> = ({
  openModal,
  closeModal,
  setCredData,
}) => {
  const [submitLoader, setSubmitLoader] = useState<boolean>(false);
  async function submitHandler() {
    try {
      setSubmitLoader(true);
      let res: AxiosResponse = await http.post("oauth/credentials/generate");
      const data = res.data.data;
      const newData = {
        clientId: data?.clientId,
        clientSecret: data?.clientSecret,
      };
      setCredData(newData);
      closeModal();
    } catch (e) {
      errorToastMessage(e as Error);
    } finally {
      setSubmitLoader(false);
    }
  }
  return (
    <Modal open={openModal} onClose={closeModal}>
      <Box sx={{ ...ModalBaseStyles, minHeight: "20vh" }}>
        <ModalHeader title="Confirm Re-generation" onCloseClick={closeModal} />
        <Typography sx={LabelStyle} fontWeight={"medium"} variant="body1">
          Are you sure you want to regenerate your API credentials? This will
          revoke and invalidate the current credentials and may block
          applications that are using these credentials
        </Typography>
        <Box sx={{ ...ModalActionButtonStyles, mt: 2.5 }}>
          {!submitLoader ? (
            <>
              <Button variant="outlined" onClick={closeModal}>
                Cancel
              </Button>
              <Button type="submit" variant="contained" onClick={submitHandler}>
                Regenerate
              </Button>
            </>
          ) : (
            <CircularProgress size={25} />
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmRegeneration;
